const DiscordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
  >
    <g clipPath="url(#clip0_1_527)">
      <path
        d="M17.6775 15.9273C19.7097 15.1467 20.8114 14.4598 21.4097 13.5808C21.1581 13.7257 20.9596 13.84 20.7612 13.9551C18.3655 15.3403 15.8019 16.0646 13.0215 15.9334C11.1117 15.8435 9.27179 15.4036 7.48132 14.7594C6.65414 14.4621 5.8528 14.0924 5.04005 13.7562C4.99976 13.7394 4.9587 13.7249 4.90624 13.731C5.82771 14.8936 7.07001 15.5553 8.46589 16.0059C8.02493 16.5593 7.60297 17.0953 7.16885 17.622C7.12095 17.68 7.00463 17.7074 6.92024 17.7059C5.2286 17.6754 3.65634 17.2172 2.26958 16.2452C1.08278 15.4143 0.594676 14.2159 0.730006 12.7758C0.956571 10.369 1.48193 8.02634 2.3783 5.78351C3.56738 2.80959 5.77677 1.08515 8.93955 0.601059C9.15471 0.568278 9.37595 0.549982 9.59187 0.564467C9.7196 0.572852 9.84201 0.65976 9.95681 0.748955C8.01048 1.2826 6.17972 1.99616 4.61049 3.27843C10.2259 0.780211 15.8254 0.804607 21.4196 3.35695C19.9203 2.1776 18.2028 1.45642 16.3835 0.907524C16.5028 0.665859 16.6739 0.564467 16.9453 0.589624C20.3164 0.905999 22.6786 2.62434 23.9711 5.75454C24.8705 7.9341 25.3974 10.2211 25.6278 12.5692C25.7775 14.0939 25.2013 15.3159 23.9293 16.1599C22.5304 17.0884 20.971 17.5473 19.2923 17.5984C19.1144 17.6037 18.9935 17.5572 18.881 17.4139C18.4956 16.923 18.0964 16.4427 17.6782 15.9281L17.6775 15.9273ZM19.2125 10.3454C19.2072 9.11193 18.1937 8.05836 17.0214 8.06675C15.8513 8.07514 14.8424 9.12337 14.8424 10.3309C14.8424 11.5591 15.8513 12.618 17.0259 12.6226C18.2074 12.6271 19.2178 11.5743 19.2125 10.3454ZM7.0282 10.3218C7.02591 11.5591 8.01504 12.6104 9.19348 12.6226C10.3582 12.6347 11.3975 11.5644 11.3975 10.3523C11.3975 9.12947 10.3772 8.06523 9.20869 8.06675C8.03785 8.06827 7.03124 9.10964 7.0282 10.3218Z"
        fill="white"
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_527">
        <rect
          width="24.9419"
          height="17.1475"
          fill="white"
          transform="translate(0.707855 0.558868)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DiscordIcon;
